import { X } from 'lucide-react';
import { Dialog as D } from 'radix-ui';
import { type ReactNode } from 'react';

import { cx } from '@/lib/cx';

import { Button } from './button';
import { estiloVeu } from './dialog';

interface SheetProps {
  aberto: boolean;
  aoMudar: (aberto: boolean) => void;
  titulo: ReactNode;
  /** Texto de apoio sob o título (lido por leitores de tela). */
  descricao?: ReactNode;
  children: ReactNode;
  /** Lado de onde a folha desliza. */
  lado?: 'direita' | 'esquerda';
  className?: string;
  /** Nome da View Transition — liga a folha ao elemento de origem (ex.: a linha da tabela). */
  nomeTransicao?: string;
}

/** Painel lateral sobre o conteúdo (gaveta de detalhe, menu no celular). */
export function Sheet({
  aberto,
  aoMudar,
  titulo,
  descricao,
  children,
  lado = 'direita',
  className,
  nomeTransicao,
}: SheetProps) {
  return (
    <D.Root open={aberto} onOpenChange={aoMudar}>
      <D.Portal>
        <D.Overlay className={estiloVeu} />
        <D.Content
          style={nomeTransicao ? { viewTransitionName: nomeTransicao } : undefined}
          className={cx(
            'fixed inset-y-0 z-50 flex w-gaveta flex-col border-borda bg-superficie-elevada shadow-alta',
            lado === 'direita' ? 'right-0 border-l' : 'left-0 border-r',
            'data-[state=open]:animate-surgir',
            className,
          )}
        >
          <header className="flex items-start justify-between gap-4 border-b border-borda px-6 py-4">
            <div className="grid min-w-0 gap-1">
              <D.Title className="text-lg font-semibold">{titulo}</D.Title>
              <D.Description className={descricao ? 'text-sm text-texto-suave' : 'sr-only'}>
                {descricao ?? 'Detalhes'}
              </D.Description>
            </div>
            <D.Close asChild>
              <Button variante="fantasma" tamanho="icone-sm" aria-label="Fechar">
                <X aria-hidden />
              </Button>
            </D.Close>
          </header>
          <div className="min-h-0 flex-1 overflow-y-auto">{children}</div>
        </D.Content>
      </D.Portal>
    </D.Root>
  );
}
